module.exports = __webpack_public_path__ + "img/loadc.17aea227.png";